import { Check, Loader2, RotateCcw, Save } from "lucide-react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";
import { useDeck } from "../../lib/deck-context";

const fmt = (iso) => new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const SaveButton = () => {
  const { modified, save, saving, saved } = useDeck();
  const onSave = async () => {
    try { await save(); toast.success("Changes saved — everyone who opens the deck now sees these numbers"); }
    catch { toast.error("Could not save. Please try again."); }
  };
  if (!modified) {
    return saved ? (
      <span data-testid="topbar-saved-status" className="hidden md:flex items-center gap-1.5 text-xs text-steel">
        <Check size={13} className="text-arq" /> Saved {fmt(saved.saved_at)}
      </span>
    ) : null;
  }
  return (
    <button data-testid="topbar-save-btn" onClick={onSave} disabled={saving} className="flex items-center gap-1.5 rounded-full bg-arq px-4 py-1.5 text-xs text-white hover:bg-arq-dark transition-colors disabled:opacity-60">
      {saving ? <Loader2 size={13} className="animate-spin" /> : <Save size={13} />} Save changes
    </button>
  );
};

export const RestoreOriginal = () => {
  const { restoreOriginal, saved, isOriginal } = useDeck();
  const run = async () => {
    try { await restoreOriginal(); toast.success("Original base case restored for everyone"); }
    catch { toast.error("Could not restore. Please try again."); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button data-testid="assumptions-restore-original-btn" disabled={!saved && isOriginal} className="w-full flex items-center justify-center gap-2 rounded-full border border-ink text-ink py-3 text-sm hover:bg-ink hover:text-white transition-colors disabled:opacity-40">
          <RotateCcw size={14} /> Restore Original Base Case
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="restore-original-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Restore the original numbers?</AlertDialogTitle>
          <AlertDialogDescription>This deletes your saved version. Everyone who opens the deck will see the original partner base case again.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="restore-original-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="restore-original-confirm" onClick={run} className="bg-arq hover:bg-arq-dark">Restore original</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
